import Vue from 'vue'
import VueRouter from 'vue-router'




Vue.use(VueRouter)

// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有生产环境使用懒加载
const _import = require('./import-' + process.env.NODE_ENV)



// 全局路由(无需嵌套上左右整体布局)
const globalRoutes = [
  { path: '/404', component: _import('common/404'), name: '404', meta: { title: '404未找到' } },
  { path: '/login', component: _import('common/login'), name: 'login', meta: { title: '登录' } },
  { path: '/register', component: _import('common/register'), name: 'register', meta: { title: '注册' } }
]

const mainRoutes = {
  path: '/',
  component: _import('root/main'),
  name: 'main',
  redirect: { name: 'login' },
  meta: { title: '主入口整体布局' },
  children: [
    { path: '/index', component: _import('modules/index/index'), name: 'index', meta: { title: '首页' } },
    { path: '/userlist', component: _import('modules/user/userlist'), name: 'userlist', meta: { title: '用户列表' } },
    { path: '/userinfo', component: _import('modules/user/userinfo'), name: 'userinfo', meta: { title: '用户信息' } },
    { path: '/useredit', component: _import('modules/user/useredit'), name: 'useredit', meta: { title: '用户编辑' } },
    { path: '/smstasklist', component: _import('modules/smsTask/smstasklist'), name: 'smstasklist', meta: { title: '短信任务' } },
    { path: '/smstaskedit', component: _import('modules/smsTask/smstaskedit'), name: 'smstaskedit', meta: { title: '短信任务编辑' } },
    { path: '/smstaskinfo', component: _import('modules/smsTask/smstaskinfo'), name: 'smstaskinfo', meta: { title: '短信任务详情' } },
    { path: '/version', component: _import('modules/version/version'), name: 'version', meta: { title: '版本管理' } },
    { path: '/versionEdit', component: _import('modules/version/versionEdit'), name: 'versionEdit', meta: { title: '版本编辑' } },
    // 通过meta对象设置路由展示方式
    // 1. isTab: 是否通过tab展示内容, true: 是, false: 否
    // 2. iframeUrl: 是否通过iframe嵌套展示内容, '以http[s]://开头': 是, '': 否
    // 提示: 如需要通过iframe嵌套展示内容, 但不通过tab打开, 请自行创建组件使用iframe处理!
    // { path: '/home', component: _import('common/home'), name: 'home', meta: { title: '首页' } },
    // { path: '/prodInfo', component: _import('modules/prod/prodInfo'), name: 'prodInfo', meta: { title: '产品详情' } }
  ],
  // beforeEnter (to, from, next) {
  //   // let authorization = Vue.cookie.get('Authorization')
  //   // if (!authorization || !/\S/.test(authorization)) {
  //   //   clearLoginInfo()
  //   //   next({ name: 'login' })
  //   // }
  //   next()
  // }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes:globalRoutes.concat(mainRoutes)
})



// router.beforeEach((to, from, next) => {
//   // 添加动态(菜单)路由
//   // 1. 已经添加 or 全局路由, 直接访问
//   // 2. 获取菜单列表, 添加并保存本地存储
//   // if (router.options.isAddDynamicMenuRoutes || fnCurrentRouteType(to, globalRoutes) === 'global') {
//   //   next()
//   // } else {
//   //   // fnAddDynamicMenuRoutes(menuList)
//   //   // http({
//   //   //   url: http.adornUrl('/sys/menu/nav'),
//   //   //   method: 'get',
//   //   //   params: http.adornParams()
//   //   // }).then(({ data }) => {
//   //   //   sessionStorage.setItem('authorities', JSON.stringify(data.authorities || '[]'))
//   //   //   fnAddDynamicMenuRoutes(data.menuList)
//   //   //   router.options.isAddDynamicMenuRoutes = true
//   //   //   sessionStorage.setItem('menuList', JSON.stringify(data.menuList || '[]'))
//   //   //   next({ ...to, replace: true })
//   //   // }).catch((e) => {
//   //   //   console.log(`%c${e} 请求菜单列表和权限失败，跳转至登录页！！`, 'color:blue')
//   //   //   router.push({ name: 'login' })
//   //   // })
//   // }
//   next()
// })

/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * @param {*} route 当前路由
 */
function fnCurrentRouteType (route, globalRoutes = []) {
  var temp = []
  for (var i = 0; i < globalRoutes.length; i++) {
    if (route.path === globalRoutes[i].path) {
      return 'global'
    } else if (globalRoutes[i].children && globalRoutes[i].children.length >= 1) {
      temp = temp.concat(globalRoutes[i].children)
    }
  }
  return temp.length >= 1 ? fnCurrentRouteType(route, temp) : 'main'
}


/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes (menuList = [], routes = []) {
  var temp = []
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].list && menuList[i].list.length >= 1) {
      temp = temp.concat(menuList[i].list)
    } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
      menuList[i].url = menuList[i].url.replace(/^\//, '')
      var route = {
        path: menuList[i].url.replace('/', '-'),
        component: null,
        name: menuList[i].url.replace('/', '-'),
        meta: {
          menuId: menuList[i].menuId,
          title: menuList[i].name,
          isDynamic: true,
          isTab: true,
          iframeUrl: ''
        }
      }
      // url以http[s]://开头, 通过iframe展示
      if (isURL(menuList[i].url)) {
        route['path'] = `i-${menuList[i].menuId}`
        route['name'] = `i-${menuList[i].menuId}`
        route['meta']['iframeUrl'] = menuList[i].url
      } else {
        try {
          route['component'] = _import(`modules/${menuList[i].url}`) || null
        } catch (e) { }
      }
      routes.push(route)
    }
  }
  if (temp.length >= 1) {
    fnAddDynamicMenuRoutes(temp, routes)
  } else {
    mainRoutes.name = 'main-dynamic'
    mainRoutes.children = routes
    router.addRoutes([
      mainRoutes,
      { path: '*', redirect: { name: '404' } }
    ])
    sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(mainRoutes.children || '[]'))
  }
}

export default router
